import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  title: {
    fontSize: 24,
    lineHeight: 30,
    color: Colors.white,
    marginTop: 21,
    marginBottom: 32,
    fontFamily: Fonts.type.VodafoneLt,
  },
  btnSuccess: theme => ({
    backgroundColor: theme.colors.activeColorTwo,
    borderWidth: 0,
  }),
  btnSuccessText: theme => ({
    fontSize: 18,
    color: theme.colors.fixedColor,
  }),
  btnReject: {
    marginTop: 16,
    backgroundColor: Colors.transparent,
    borderWidth: 1,
    borderColor: Colors.white,
    marginBottom: 10,
  },
  btnRejectText: theme => ({
    fontSize: 18,
    color: theme.colors.activeColorTwo,
  }),
  headerStyle: {
    marginHorizontal: 0,
  },
});
